<template>
    <!-- 分页 -->
    <div class="page">
        <div class="block">
            <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage3"
                :page-size="PageSize"
                layout="prev, pager, next, jumper"
                :total="totals"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    
};
</script>
<style lang="scss">
.page {
    .block {
        text-align: center;
    }
}
</style>

